import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import { RouterProvider } from 'react-router-dom';

import 'utils/i18n';
import 'utils/sentry';

import store from 'redux/redux-store';
import 'normalize.css';
import 'assets/global.scss';
import ErrorBoundaryFallback from 'App/ErrorBoundaryFallback';
import { logError } from 'utils/errorHandling';

import LoadingSpinner from './components/ui/LoadingSpinner';
import router from './routes/router';

if (navigator.userAgent.indexOf('Windows') !== -1) {
    require('./assets/scroll.scss');
}

const container = document.getElementById('root');
if (!container) {
    throw new Error('No root element found');
}

const root = createRoot(container);

root.render(
    <Suspense fallback={<LoadingSpinner />}>
        <Provider store={store}>
            {/* Todo: Review error handling and add error boundaries at critical locations*/}
            <ErrorBoundary
                fallbackRender={ErrorBoundaryFallback}
                onError={(error, info) => logError('Router failed to render', error, info)}
            >
                <RouterProvider router={router} />
            </ErrorBoundary>
        </Provider>
    </Suspense>,
);
export { logApiError } from 'utils/errorHandling';
